import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import isValidUser from '../../lib/isValidUser';
import { ServiceUserUtils } from '../../lib/serviceUserUtils';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

/**
 * The rescind event indicates that an offer has been rescinded from
 * the recipient. This could happen for example if a session hung-up
 * while it was being offered.
 * @param event
 */
async function handleAgentSessionRescinded(
  event: Telecom.AgentSessionRescindedEvent,
) {
  // Track RTCS event latency - CRITICAL for diagnosing ghost ringing when another agent answers
  trackRTCSEventLatency(event.timestamp, RTCSEventType.SESSION_RESCINDED);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:session_rescinded:' + user?.name, event);

  user.stats = userStatsFromAgentStats(event.stats);

  ServiceUserUtils.setEventActivityStatus(user, '');
  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.RESCINDED,
    {
      sessionId: event.conversationId ?? '',
      sessionSid: event.conversationSid ?? '',
      agentId: event.agentId,
      userId: user.id,
    },
  );
}

export default handleAgentSessionRescinded;
